<template>
    
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/administration">{{lang.LBL_ADMIN}}</router-link></li>
        <li><router-link to="/modules/schedulers/edit">{{lang.LBL_ADD_SCHEDULERS}}</router-link></li>
        <li><router-link to="/modules/schedulers">{{lang.LBL_VIEW_SCHEDULERS}}</router-link></li>
    </ul>
            

</template>
<script>
import lang from "@/views/modules/Schedulers/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
        }
     },
     mounted() {
        this.lang = lang;
    },
     
}
</script>
